import React, { type ReactNode, Suspense, useEffect, useRef, useState } from 'react';
declare global {
  interface Window {
    requestIdleCallback?: (callback: () => void, options?: {
      timeout: number;
    }) => number;
    cancelIdleCallback?: (handle: number) => void;
  }
}
interface DeferredSectionProps {
  children: ReactNode;
  minHeight?: number;
}
export function DeferredSection({
  children,
  minHeight = 360
}: DeferredSectionProps) {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const target = sectionRef.current;
    if (!target || !('IntersectionObserver' in window)) {
      setIsVisible(true);
      return;
    }
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.disconnect();
      }
    }, {
      rootMargin: '900px 0px'
    });
    observer.observe(target);
    return () => observer.disconnect();
  }, []);
  return <div ref={sectionRef} style={!isVisible ? {
    minHeight
  } : undefined} data-id="element-70" data-mp="vc4ykghenksq">
      {isVisible ? <Suspense fallback={<div style={{
      minHeight
    }} data-id="element-72" data-mp="10ag8ssbm3xbh" />} data-id="element-71" data-mp="10azffcvtaza7">{children}</Suspense> : null}
    </div>;
}